// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#fixedbottom[data-v-59fec8fa] {\r\n  background-color: #fff;\n}\n.fixed-button-custom[data-v-59fec8fa] {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 118px;\r\n  z-index: 1030;\n}\r\n", ""]);
// Exports
module.exports = exports;
